import React from 'react'
import {
  Chip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core'
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined'

import { useHistory } from 'react-router-dom'
import { SynRoutes } from 'src/core/consts/synRoutes'
import { LockOutlined, DynamicFeed, SdCardOutlined } from '@material-ui/icons'
import { FaTasks } from 'react-icons/fa'
import UBox from 'src/components/ui/Ubox'
import useAtividade from 'src/hooks/useAtividade'
import config from 'src/config'
import { gerarAuthCode } from 'src/api/auth/index'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney'
import useAuth from 'src/hooks/useAuth'
import { SynPerfis } from 'src/core/consts/synPerfis'

function menuLateral() {
  const history = useHistory()
  const { perfilAtual } = useAuth()
  const { obterQtdePendente } = useAtividade()

  return (
    <List>
      <ListItem
        button
        onClick={() => history.push('/')}
        id="submenus-solicitacoes"
      >
        <ListItemIcon>
          <AssignmentOutlinedIcon />
        </ListItemIcon>
        <ListItemText primary="Solicitações" />
      </ListItem>
      <ListItem
        button
        onClick={() => history.push(SynRoutes.alterarSenha)}
        id="submenus-alterar-senha"
      >
        <ListItemIcon>
          <LockOutlined />
        </ListItemIcon>
        <ListItemText primary="Alterar senha" />
      </ListItem>
      <ListItem
        button
        onClick={() => history.push(SynRoutes.termos)}
        id="submenus-termos"
      >
        <ListItemIcon>
          <SdCardOutlined />
        </ListItemIcon>
        <ListItemText primary="Termos" />
      </ListItem>
      {/* <ListItem button onClick={() => history.push(SynRoutes.historicoAtualizacoes)}>
        <ListItemIcon>
          <DynamicFeed />
        </ListItemIcon>
        <ListItemText primary="Atualizações" />
      </ListItem> */}

      <ListItem
        button
        onClick={() => history.push(SynRoutes.tarefas)}
        id="submenus-atividades"
      >
        <ListItemIcon style={{ fontSize: '1.3rem' }}>
          {/* <FcTodoList /> */}
          <FaTasks />
        </ListItemIcon>
        <ListItemText
          primary={
            <UBox>
              Atividades{' '}
              {obterQtdePendente() > 0 && (
                <Chip
                  variant="default"
                  color="secondary"
                  size="small"
                  label={obterQtdePendente()}
                />
              )}
            </UBox>
          }
        />
      </ListItem>

      {(perfilAtual === SynPerfis.TESOURARIA_HOSPITAL ||
        perfilAtual === SynPerfis.ADMIN_HOSPITAL) && (
        <ListItem
          button
          onClick={async () => {
            const code = await gerarAuthCode()
            window.location.href = `${config.baseUrlV2}?code=${code}`
          }}
          id="submenus-financeiro"
        >
          <ListItemIcon style={{ fontSize: '1.4rem' }}>
            <AttachMoneyIcon />
          </ListItemIcon>
          <ListItemText primary="Financeiro" />
        </ListItem>
      )}
    </List>
  )
}

export default menuLateral
